import { render, staticRenderFns } from "./serviceTotal.vue?vue&type=template&id=2c68a428&scoped=true&"
import script from "./serviceTotal.vue?vue&type=script&lang=js&"
export * from "./serviceTotal.vue?vue&type=script&lang=js&"
import style0 from "./serviceTotal.vue?vue&type=style&index=0&id=2c68a428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68a428",
  null
  
)

export default component.exports